import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const solutionData = {
  id: 'cartography',
  name: 'Spatial Planning',
  icon: <LocationOnIcon sx={{ fontSize: 60 }} />,
  description: 'Comprehensive spatial planning and urban development solutions',
  overview: `Our spatial planning services provide strategic solutions for urban and regional development, ensuring sustainable growth and efficient land use. We specialize in creating comprehensive spatial plans that integrate environmental, social, and economic considerations to support informed decision-making and sustainable development.`,
  features: [
    {
      title: 'Urban Development Planning',
      description: 'Strategic planning for sustainable urban growth and development',
    },
    {
      title: 'Land Use Analysis',
      description: 'Comprehensive analysis of land use patterns and potential',
    },
    {
      title: 'Zoning and Development Control',
      description: 'Development of zoning regulations and control mechanisms',
    },
    {
      title: 'Infrastructure Planning',
      description: 'Strategic planning for transportation and utility networks',
    },
    {
      title: 'Environmental Impact Assessment',
      description: 'Evaluation of development impacts on the environment',
    },
    {
      title: 'Community Engagement',
      description: 'Inclusive planning processes with stakeholder participation',
    },
  ],
  benefits: [
    'Sustainable urban development',
    'Efficient land use management',
    'Improved infrastructure planning',
    'Enhanced environmental protection',
    'Inclusive development processes',
    'Long-term strategic vision',
  ],
};

const Cartography = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default Cartography; 